'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (hierarchy, state) {
  return hierarchy.reduce(function (selectorState, currentElem, index) {
    var validClasses = (0, _lodash2["default"])(currentElem.getClasses(), 10).filter(_validationHelpers.className).map(function (className) {
      return '.' + className;
    });

    if (validClasses.length) {
      // limit to 10 classes
      selectorState.stack[index].push(validClasses.join(''));
      selectorState.specificity += 10 * validClasses.length;
    }

    return selectorState;
  }, state);
};

var _lodash = require('lodash.take');

var _lodash2 = _interopRequireDefault(_lodash);

var _validationHelpers = require('./validationHelpers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}